import React, { useState, useEffect, useCallback, useMemo } from 'react';
import QRCode from 'react-qr-code';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  ButtonBase,
  Box,
  CircularProgress,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { ExpandMore, ThumbUp, ThumbDown } from '@material-ui/icons';
// import { Alert } from '@material-ui/lab';
import { parse, isAfter, isValid } from 'date-fns';
import {
  isArray,
  assign,
  isEmpty,
  reduce,
  includes,
  isUndefined,
  isNull,
} from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import qs from 'querystring';
import * as Yup from 'yup';

import { Spinner, Table } from '~/components';
import {
  Form as FormUI,
  Autocomplete,
  Input,
  DateTime,
  Select,
  Hidden,
} from '~/components/Form';
import { t, number, can, removerMascaraCNPJ } from '~/helpers';
import api from '~/services/api';

import DeleteButtonWithModal from '../DeleteButtonWithModal';
import PesquisaTabelaInput from '../PesquisaTabelaInput';

import * as S from './styles';

const useStyles = makeStyles({
  table: {
    maxWidth: 650,
  },
});

const VericaXMLChegou = React.forwardRef((props, ref) => {
  const { onCloseModal, formEdit } = props;

  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(false);

  const [itemsLocal, setItemsLocal] = useState([]);

  // Open Modal
  const openModal = React.useCallback(() => {
    setLoading(true);
    setOpen(true);
  }, []);

  // Close Modal
  const closeModal = React.useCallback(() => {
    setOpen(false);
    setTimeout(() => {
      onCloseModal(); // Aqui ele chama o handleCloseVerifica no pai
    }, 300);
  }, []);

  const handleCallbackClose = React.useCallback(() => {
    onCloseModal();
  }, []);

  // Schema Validade
  const schemaValidade = React.useMemo(() => Yup.object().shape({}), []);

  const cellsHistorico = useMemo(
    () => [
      {
        id: 'nfre_numero',
        label: t('s.operacao.checkliberadoparaintegracao.nfre_numero'),
      },
      {
        id: 'erro',
        label: t('s.operacao.checkliberadoparaintegracao.nfre_erro'),
      },
    ],
    []
  );

  // Submit form
  const handleSubmit = React.useCallback(
    async (data) => {
      try {
        await schemaValidade.validate(data, {
          abortEarly: false,
        });
        closeModal();
      } catch (err) {
        const validationErrors = {};
        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });
        }
      }
    },
    [formEdit]
  );

  // Export functions
  React.useImperativeHandle(ref, () => ({
    openModal,
  }));

  const handleProcessaXMLRumoPendente = React.useCallback(async (nf, tank) => {
    try {
      setLoading(true);
      const response = await api.put(
        `checkxmlnfrecebimentonf/processaXMLRumoPendente`
      );
      setItemsLocal(response.data);
      // console.log(JSON.stringify(response?.data))
      // setResumoBolAbs(response.data.volumesaidadescarganftanque);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
      // setItemsLocal([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      handleProcessaXMLRumoPendente();
    }, 1000);

    return () => clearTimeout(timeOut);
  }, []);

  if (loading)
    return (
      <S.Loading>
        <CircularProgress />
      </S.Loading>
    );

  return (
    <Dialog
      disableEscapeKeyDown
      disableBackdropClick
      open={open}
      fullScreen={window.innerWidth <= 450 ? window.innerWidth <= 450 : false}
      maxWidth={window.innerWidth <= 450 ? 0 <= 450 : 'xl'}
      // maxWidth="xl"
      // onExit={handleCallbackClose}
      onClose={closeModal}
      // onExited={handleCallbackClose}
    >
      <DialogTitle>{t('s.menu.operacao.checkxmlnfrecebimentonf')}</DialogTitle>

      <DialogContent>
        <Table
          isResponsive
          size="small"
          height="18rem"
          paginate={99}
          showPagination={false}
          cells={cellsHistorico}
          data={itemsLocal ?? []}
          loding={loading}
        />
      </DialogContent>

      <DialogActions>
        <Button
          // onClick={() => closeModal()}
          onClick={() => {
            closeModal();
            // handleCallbackClose(); // aqui garante que será chamado mesmo no botão
          }}
          color="secondary"
          variant="outlined"
        >
          {t('s.geral.botaofechar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

VericaXMLChegou.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  formEdit: PropTypes.objectOf(PropTypes.any),
};

VericaXMLChegou.defaultProps = {
  formEdit: {},
};

export default VericaXMLChegou;
